module.exports = __webpack_public_path__ + "img/AppStoreQR2.7b76bd93.svg";